export const DIDOX_DOCUMENTS = 'DIDOX_DOCUMENTS';
export const DIDOX_DOCUMENTS_BY_EMP_ID = 'DIDOX_DOCUMENTS_BY_EMP_ID';
export const DIDOX_CURRENT_DOC = 'DIDOX_CURRENT_DOC';